// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__-jTUW","header":"App_header__1AVHb","page":"App_page__RaUFD"};